import axios from "axios";
import ambiente from "./ambiente";
import { getToken } from "./auth";


const api = axios.create({
  baseURL: ambiente.URL_REPORTS,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers = {
      "Authorization": `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*"
    };
  }
  return config;
});

export default api;
